import { makeStyles } from '@material-ui/core/styles'
import DoneIcon from 'src/assets/Buy_Policy_Images/DoneIcon.svg'
import {
  BUY_CAR_INSURANCE_OPTION_TYPES,
  CAR_DETAILS_TAB_TYPES,
  CAR_DETAILS_TABS,
} from 'src/utils/constants/BuyPolicy'

const CarDetailsTabs = ({
  buyInsuranceType,
  carDetails,
  selectedTab,
  onTabChange,
}) => {
  const classes = useStyles()

  const highlightTab = (tabDetails) => {
    return tabDetails?.type === selectedTab || isValidTabValue(tabDetails)
  }

  const showTab = (tabType) => {
    return !(
      tabType === CAR_DETAILS_TAB_TYPES?.price &&
      buyInsuranceType !== BUY_CAR_INSURANCE_OPTION_TYPES?.newCar
    )
  }

  const isValidTabValue = (tabDetails) => {
    return !!carDetails?.[tabDetails?.key]
  }

  const getTabValue = (tabDetails) => {
    return `${tabDetails?.type === CAR_DETAILS_TAB_TYPES?.price ? 'Rs. ' : ''}${
      carDetails?.[tabDetails?.key]?.value
    }`
  }

  const handleTabChange = (tabDetails) => {
    onTabChange(tabDetails)
  }

  return (
    <>
      <div className={classes.titleMainContainer}>
        <div className={classes.titleContainer}>
          <span className={classes.title}>Please fill the details</span>
        </div>
        <div className={classes.tabsContainer}>
          {CAR_DETAILS_TABS?.map((tabDetails) => {
            return showTab(tabDetails?.type) ? (
              <div
                id='tab'
                className={`${classes.tab} ${
                  highlightTab(tabDetails) ? classes.highlightTab : null
                }`}
                key={tabDetails?.type}
                onClick={() => handleTabChange(tabDetails)}
              >
                <div className={classes.tabTitleContainer}>
                  {isValidTabValue(tabDetails) ? (
                    <>
                      <span className={classes.tabTitle}>
                        {getTabValue(tabDetails)}{' '}
                      </span>
                      <img
                        src={DoneIcon}
                        alt={'Done'}
                        className={classes.doneImage}
                      />
                    </>
                  ) : (
                    <span className={classes.tabTitle}>
                      {tabDetails?.label}
                    </span>
                  )}
                </div>
              </div>
            ) : null
          })}
        </div>
      </div>
    </>
  )
}

export default CarDetailsTabs

const useStyles = makeStyles({
  titleMainContainer: {
    padding: '0px 10px',
  },
  titleContainer: {
    padding: '10px 0px',
    textAlign: 'center',
  },
  title: {
    fontFamily: 'Roboto',
    fontSize: '15px',
    fontWeight: '400',
  },
  tabsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  tab: {
    boxShadow: '0px 4px 4px 0px #A3DDED',
    padding: '5px 20px',
    borderRadius: '5px',
    background: '#FFFFFF',
    opacity: '0.5',
    cursor: 'pointer',
    height: '27px',
    display: 'flex',
  },
  highlightTab: {
    opacity: 'unset',
  },
  tabTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: '100%',
  },
  tabTitle: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 600,
    textAlign: 'center',
    wordBreak: 'break-word',
  },
  doneImage: {
    position: 'absolute',
    right: '0',
  },
})
